<template>
  <v-row class="pt-5">
    <v-col cols="12">
      <h2 class="headline mb-4 purple--text text--lighten-2">Competition</h2>
    </v-col>
    <v-col cols="12">
      <p class="purple--text text--lighten-4">Art Institutions</p>
      <v-row>
        <v-col cols="6" v-for="(tag, index) in doc.list1" :key="`q1-${index}`">
          <v-card light>
            <v-card-title>{{ tag.title }}</v-card-title>
            <v-card-text>
              <p class="pb-0 mb-0 black--text">What makes them unique to SF?</p>
              <p class="pb-0 mb-2">{{ tag.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ tag.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ tag.difference }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <p class="purple--text text--lighten-4">Cultural Institutions</p>
      <v-row>
        <v-col cols="6" v-for="(tag, index) in doc.list2" :key="`q2-${index}`">
          <v-card light>
            <v-card-title>{{ tag.title }}</v-card-title>
            <v-card-text>
              <p class="pb-0 mb-0 black--text">What makes them unique to SF?</p>
              <p class="pb-0 mb-2">{{ tag.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ tag.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ tag.difference }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <p class="purple--text text--lighten-4">Other Institutions</p>
      <v-row>
        <v-col cols="6" v-for="(tag, index) in doc.list3" :key="`q3-${index}`">
          <v-card light>
            <v-card-title>{{ tag.title }}</v-card-title>
            <v-card-text>
              <p class="pb-0 mb-0 black--text">What makes them unique to SF?</p>
              <p class="pb-0 mb-2">{{ tag.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ tag.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ tag.difference }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">
        Local flavours
      </h3>
    </v-col>
    <v-col cols="3">
      <results-list
        :title="content.exercise_culture_knowledge.questions[2].title"
        :items="doc.matrix.q3"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="3">
      <results-list
        :title="content.exercise_culture_knowledge.questions[3].title"
        :items="doc.matrix.q4"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="3">
      <results-list
        :title="content.exercise_culture_knowledge.questions[4].title"
        :items="doc.matrix.q5"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="3">
      <results-list
        :title="content.exercise_culture_knowledge.questions[5].title"
        :items="doc.matrix.q6"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">
        San Francisco Life
      </h3>
    </v-col>
    <v-col cols="4">
      <results-list
        :title="content.exercise_culture_knowledge.questions[6].title"
        :items="doc.matrix.q7"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="4">
      <results-list
        :title="content.exercise_culture_knowledge.questions[7].title"
        :items="doc.matrix.q8"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="4">
      <results-list
        :title="content.exercise_culture_knowledge.questions[8].title"
        :items="doc.matrix.q9"
        inner-class="yellow--text"
      />
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsList from "./ResultsList";

export default {
  name: "ResultsCompetition",
  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },
  data() {
    return {
      items: null,
      doc: null,
      content: {},
      admins: null,
      results: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
        q5: [],
        q6: [],
        q7: [],
        q8: [],
        q9: [],
      },
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getExercise();
        }
      },
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  components: {
    ResultsList,
  },
  mounted() {},
  methods: {
    getExercise() {
      this.doc = null;
      let ref = fb.cultureKnowledgeExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            console.log("items", items);
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },

    getResults(doc) {
      this.pushToArray(doc.matrix.q1, "q1");
      this.pushToArray(doc.matrix.q2, "q2");
      this.pushToArray(doc.matrix.q3, "q3");
      this.pushToArray(doc.matrix.q4, "q4");
      this.pushToArray(doc.matrix.q5, "q5");
      this.pushToArray(doc.matrix.q6, "q6");
      this.pushToArray(doc.matrix.q7, "q7");
      this.pushToArray(doc.matrix.q8, "q8");
      this.pushToArray(doc.matrix.q8, "q9");
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        console.log(arr);
        arr.forEach((y) => {
          this.results[model].push(y);
        });
      }
    },
  },
};
</script>
